
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:flex;
  flex:1;
}

.news-card{
  display:flex;
  flex-direction:column;
  flex-grow:1;
  flex-shrink:0;
  font-family:var(--ff-display);
  background-color:var(--brand-white);
  box-shadow:0 0 40px 5px rgba(4, 30, 74, 0.1);
  position:relative;
  width:100%;
  height:100%;
  z-index:1;
  cursor:pointer;
  transition:transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.news-card:hover{
    transform:translateY(-10px);
    box-shadow:0 10px 20px 2px rgba(4, 30, 74, 0.25);
  }

.news-card .content{
    display:flex;
    flex-direction:column;
    justify-content:start;
    padding:var(--spacing-5);
    height:100%;
  }

@media (min-width: 1024px){

.news-card .content{
      padding:var(--spacing-8)
  }
    }

.news-card .tag{
    margin-bottom:var(--spacing-3);
  }

.news-card .title{
    --heading-color:var(--brand-dark-blue-900);

    font-size:var(--fs-h3-small);
    line-height:var(--lh-h3-medium);
    margin-bottom:var(--spacing-4);
  }

@media (min-width: 1024px){

.news-card .title{
      font-size:var(--fs-h3);
      line-height:var(--lh-h2-small)
  }
    }

.news-card .cta{
    flex-grow:1;
    align-items:flex-end;
    display:flex;
  }

img{
  max-width:100%;
  vertical-align:middle;
  object-fit:cover;
}
`;